"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_LIST_HEIGHT = exports.DEFAULT_LIST_WIDTH = exports.DEFAULT_MIN_BUFFER_SIZE = void 0;
// @ts-nocheck
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const ErrorDisplay_1 = __importDefault(require("./ErrorDisplay"));
const react_window_1 = require("react-window");
const react_virtualized_auto_sizer_1 = __importDefault(require("react-virtualized-auto-sizer"));
const react_window_infinite_loader_1 = __importDefault(require("react-window-infinite-loader"));
exports.DEFAULT_MIN_BUFFER_SIZE = 10;
exports.DEFAULT_LIST_WIDTH = '100%';
exports.DEFAULT_LIST_HEIGHT = '100%';
/**
 * A component that combines DialogWrapper header with lazy list
 * @param props
 */
const TGLazyModalList = (props) => {
    const { searchText, state, setState, rowRendererProps, rowHeight, data, error, loading, fetchMoreData, hasNextPage, } = props;
    const [, setCurrentDataKey] = react_1.useState(0);
    const [scroll,] = react_1.useState(0);
    const expectedScroll = react_1.useRef(0);
    const listRef = react_1.useRef(null);
    const refresh = react_1.useCallback(() => {
        setCurrentDataKey((currentKey) => currentKey + 1);
    }, []);
    react_1.useEffect(() => {
        var _a;
        (_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.scrollToItem(0);
        // When search text changes we need to scroll to the top of the list
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchText]);
    react_1.useEffect(() => {
        expectedScroll.current = scroll;
        // We only need to update scroll when data is changed, because then the list rerenders
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);
    const MemorizedRowRenderer = react_1.useCallback((rendererProps) => (react_1.default.createElement(props.rowRenderer, Object.assign({}, rendererProps, { state: state, setState: setState, refresh: refresh, generalProps: rowRendererProps }))), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state, setState, refresh, rowRendererProps]);
    if (error) {
        return react_1.default.createElement(ErrorDisplay_1.default, { error: error });
    }
    const Row = (innerProps) => {
        const { index, style } = innerProps;
        const item = data[index];
        return react_1.default.createElement(MemorizedRowRenderer, { row: item, style: style });
    };
    const itemCount = hasNextPage ? data.length + 1 : data.length;
    const isItemLoaded = (index) => !!data[index];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_virtualized_auto_sizer_1.default, null, ({ height, width }) => (react_1.default.createElement(react_window_infinite_loader_1.default, { isItemLoaded: isItemLoaded, itemCount: itemCount, loadMoreItems: () => fetchMoreData() }, ({ onItemsRendered, ref }) => (react_1.default.createElement(react_window_1.FixedSizeList, { height: height, itemCount: data.length || 0, itemSize: rowHeight, onItemsRendered: onItemsRendered, ref: (el) => {
                ref(el);
                listRef === null || listRef === void 0 ? void 0 : listRef.current = el;
            }, width: width }, Row))))),
        loading &&
            react_1.default.createElement("div", { style: { position: 'absolute', left: '50%', bottom: 0 } },
                react_1.default.createElement(core_1.CircularProgress, { size: 32 }))));
};
exports.default = TGLazyModalList;
//# sourceMappingURL=TGLazyModalList.js.map